'use strict';

export const toggle = (() => {
    const itemToggle = event => {
        const $this = $(event.currentTarget);

        $this.parent('.js-toggle-content').toggleClass('is-close');
    };

    const toggleSet = () => {
        $('.js-toggle-body').each((index, element) => {
            const $this = $(element);

            const toggleHeight = $this.find('.js-toggle-inner').outerHeight();
            $this.height(toggleHeight);
        });
    }

    const init = () => {
        toggleSet();

        $('.js-toggle-button').on('click', event => {
            itemToggle(event);
        });
    };

    return {
        init: init
    };
})();
